import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {EffectCreative, Keyboard, Navigation, Scrollbar} from "swiper/modules"

const rollerSliders = document.querySelectorAll<HTMLElement>(".g-roller-slider")

rollerSliders.forEach((slider) => {
  const sliderScrollbar = slider.querySelector<HTMLElement>(".g-roller-slider__scrollbar.swiper-scrollbar");
  const sliderButtons = slider.closest(".s-roller-slider__slider")?.querySelector<HTMLElement>(".g-roller-slider__buttons");
  const sliderImg = slider.querySelector<HTMLElement>(".i-roller-slider .img");

  if (!sliderButtons || !sliderImg) return;

  let halfImg: number

  const setButtonsOffset = (top: number) => {
    sliderButtons.style.setProperty("top", `${top.toString()}px`)
  }

  setTimeout(() => {
    halfImg = sliderImg.clientHeight / 2
    setButtonsOffset(halfImg)
  })

  window.addEventListener("resize", () => {
    halfImg = sliderImg.clientHeight / 2;
    setButtonsOffset(halfImg)
  })

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, EffectCreative, Navigation, Scrollbar],
    slidesPerView: 1,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.closest(".s-roller-slider__slider")?.querySelector<HTMLElement>(".g-roller-slider__button.--next"),
      prevEl: slider.closest(".s-roller-slider__slider")?.querySelector<HTMLElement>(".g-roller-slider__button.--prev"),
    },
    breakpoints: {
      1200: {
        slidesPerView: 2,
        spaceBetween: 32,
      }
    },
    scrollbar: {
      el: sliderScrollbar,
      draggable: true,
      dragSize: 'auto',
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
      resize(swiper) {
        swiper.scrollbar.setTranslate()
        swiper.scrollbar.updateSize()
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
